import { render, staticRenderFns } from "./ComplaintAllView.vue?vue&type=template&id=219c475d"
import script from "./ComplaintAllView.vue?vue&type=script&lang=js"
export * from "./ComplaintAllView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports